export const insertId = obj => {
  for (var key in obj) {
    if (Array.isArray(obj[key])) {
      arrayItem(obj[key]);
    } else if (typeof obj[key] === 'object' && obj[key]) {
      insertId(obj[key]);
    }
  }
  if (!obj._id) {
    obj._id = Math.random() * 1000;
  }
  return obj;
};

const arrayItem = obj => {
  obj.forEach(item => {
    insertId(item);
  });
};
